import { render, staticRenderFns } from "./SharePointPreviewerModal.vue?vue&type=template&id=4d9ffed0&scoped=true"
import script from "./SharePointPreviewerModal.vue?vue&type=script&lang=js"
export * from "./SharePointPreviewerModal.vue?vue&type=script&lang=js"
import style0 from "./SharePointPreviewerModal.vue?vue&type=style&index=0&id=4d9ffed0&prod&lang=scss"
import style1 from "./SharePointPreviewerModal.vue?vue&type=style&index=1&id=4d9ffed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9ffed0",
  null
  
)

export default component.exports